import { buttonOutlineDark } from '@barracuda/shared/styles/button';
import { theme } from '@theme';

export const helpCenterHeader = {
  backgroundColor: theme.palette.common.feedbackInfo20,
  maxWidth: '1216px',
  marginInline: 'auto',
  padding: {
    mobile: '64px 48px',
    tablet: '0 32px'
  },
  flexDirection: 'row',
  justifyContent: 'space-between'
};

export const helpCenterHeaderTitle = {
  fontSize: '48px',
  lineHeight: '56px',
  fontWeight: 700,
  color: theme.palette.common.darkGrey13
};

export const helpCenterHeaderText = {
  color: theme.palette.common.darkGrey13,
  lineHeight: 1.5,
  marginTop: '24px'
};

export const helpCenterContent = {
  maxWidth: '1216px',
  marginInline: 'auto',
  padding: {
    mobile: '32px 24px',
    tablet: '48px 32px',
    desktop: '48px 0'
  }
};

export const helpCenterSidebarBox = {
  backgroundColor: theme.palette.common.white,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.common.sectionTertiary}`,
  padding: '20px 32px'
};

export const helpCenterCategoriesHeader = {
  fontWeight: 600,
  color: theme.palette.common.darkBlue2,
  lineHeight: 1.5,
  marginBottom: '24px'
};

export const helpCenterCtaWrapper = {
  ...helpCenterSidebarBox,
  marginTop: { tablet: '32px' },
  alignItems: 'center',
  padding: '48px'
};

export const helpCenterCtaHeader = {
  color: theme.palette.common.primaryDark,
  marginTop: '32px',
  fontWeight: 600,
  textAlign: 'center',
  lineHeight: '24px'
};

export const helpCenterCtaText = {
  color: theme.palette.common.primaryDark,
  lineHeight: 1.5,
  textAlign: 'center',
  marginTop: '12px'
};

export const helpCenterCtaButton = {
  ...buttonOutlineDark,
  marginTop: '24px'
};

export const helpCenterCategoryTitle = {
  fontSize: '24px',
  lineHeight: '32px',
  color: theme.palette.common.darkGrey11,
  marginBottom: '40px',
  fontWeight: 600
};

export const helpCenterMobileCategories = {
  backgroundColor: theme.palette.common.white,
  borderRadius: '8px',
  marginTop: '8px',
  width: '100%',
  '& .MuiSelect-select.MuiInputBase-input': {
    padding: '12px 42px 12px 12px',
    minHeight: '24px'
  },
  '& .MuiSelect-select.MuiInputBase-input[aria-expanded="true"] ~ img': {
    transform: 'rotate(180deg)'
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.common.lightGrey14
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.common.lightGrey14
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.common.lightGrey14
  }
};

export const helpCenterCategoriesCaretDown = {
  position: 'relative',
  pointerEvents: 'none',
  marginLeft: '-24px',
  left: '-10px',
  transition: 'transform 0.1s ease-in-out'
};

export const helpCenterArticlesContainer = {
  backgroundColor: theme.palette.common.white,
  padding: '48px',
  borderRadius: '8px',
  border: `1px solid ${theme.palette.common.sectionTertiary}`
};

export const helpCenterFadeInAnimation = {
  animation: 'fadeIn 0.2s ease-in',
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 }
  }
};
